import * as jwt from "jsonwebtoken";
import {GlobalConstants} from "../data/GlobalConstants";
import { store } from '../store/store'

export const getToken = () => {
    return store.getState().auth?.token;
}

export const validToken = (token) => (
    jwt.verify(token ? token : getToken(), GlobalConstants.key, function(err, decoded) {
        if(err){
            return {error:true,decoded:{}}
        }
        else if(decoded){
            return {
              error:false,
              decoded:{
                  idUsuario: decoded.sub,
                  nombre: decoded.nombre,
                  tipoUsuario: decoded.tipoUsuario,
                  avatar: decoded.avatar
              }
            }
        }
    })
)



